import { Book } from 'react-bootstrap-icons';
import { FormattedMessage } from 'react-intl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Header() {
  return /*#__PURE__*/_jsxs("div", {
    className: "text-center pt-4",
    children: [/*#__PURE__*/_jsx(Book, {
      className: "icon h1"
    }), /*#__PURE__*/_jsx("h1", {
      className: "h4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "header.title"
      })
    })]
  });
}